import styled from 'styled-components';

const Base = styled.div`
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
`;

const Layout = styled(Base)``;

const SlotContainer = styled.div`
	position: absolute;
	top: ${p => p.top || 0}%;
	left: ${p => p.left || 0}%;
	width: ${p => p.width || 100}%;
	height: ${p => p.height || 100}%;
	box-shadow: 0px 0px 0px 2px white;
`;

const ImageComponent = styled(Base)``;

const ImageThumb = styled(SlotContainer)`
	background-repeat: no-repeat;
	background-position: ${p => p.positionX}% ${p => p.positionY}%;
	background-size: ${p => p.size};
	background-image: url(${p => p.url});
`;

const TextComponent = styled(Base)`
	background-color: rgba(240,240,240,1);
	box-shadow: 0px 0px 0px 2px white;
`;

const PictogramComponent = styled(Base)`
	background-color: rgba(240,240,240,1);
	box-shadow: 0px 0px 0px 2px white;
`;

const BlankComponent = styled(Base)`
	background-color: rgba(240,240,240,1);
	box-shadow: 0px 0px 0px 2px white;
`;

export {
	Layout,
	SlotContainer,
	ImageComponent,
	TextComponent,
	PictogramComponent,
	ImageThumb,
	BlankComponent,
}
